/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Aux from '../AuxComponent';
import styles from './Tabs.module.css';

const Tabs = (props) => {
    const { activeTab, onTabChange, children, tabsStyle, tabsContainerStyle, showGrey } = props;

    const [tabHeader, setTabHeader] = useState([]);
    const [childContent, setChildContent] = useState({});
    const [active, setActive] = useState(null);

    useEffect(() => {
        const headers = [];
        const childCnt = {};
        React.Children.forEach(children, (element) => {
            if (!React.isValidElement(element)) return;
            const { id, name } = element.props;
            headers.push({ id, name });
            childCnt[id] = element.props.children;
        });
        setTabHeader(headers);
        // setActive(headers[0]);
        setChildContent({ ...childCnt });
    }, [children]);

    useEffect(() => {
        setActive(activeTab);
    }, [activeTab]);

    const changeTab = (id) => {
        // setActive(id);
        onTabChange && onTabChange(id);
    };

    return (
        <div className={tabsContainerStyle}>
            <ul className={[styles.tabHeader, tabsStyle].join(' ')}>
                {tabHeader.map((item) => (
                    <li
                        onClick={() => changeTab(item.id)}
                        key={item.id}
                        className={item.id === active ? showGrey ? styles.activeGrey : styles.active : showGrey ? styles.inactiveGrey : styles.inactive}
                    >
                        {item.name}
                    </li>
                ))}
            </ul>
            <>
                {Object.keys(childContent).map((key) => {
                    if (key == active) {
                        return <React.Fragment key={key}>{childContent[key]}</React.Fragment>;
                    } else {
                        return null;
                    }
                })}
            </>
        </div>
    );
};

Tabs.propTypes = {
    children: function (props, propName, componentName) {
        const prop = props[propName];

        let error = null;
        React.Children.forEach(prop, function (child) {
            if (child.type !== Aux) {
                error = new Error(
                    "`" + componentName + "` children should be of type `Aux`."
                );
            }
        });
        return error;
    },
    activeTab: PropTypes.any,
    onTabChange: PropTypes.func,
    tabsStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    tabsContainerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Tabs;
